import {SActionBtn, SBack, SLowcodeList, SMessage, STableActions} from "shj-components";
import {useEffect, useMemo, useRef} from "react";
import {config} from './config.tsx'
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {AddOrEditDom} from "./addOrEdit/addStaff.tsx";
import {useSetState} from "ahooks";
import {AddOrEditRange} from "./addOrEdit/configRange.tsx";
import {apiData2Table} from "@/utils/data.ts";
import {employeePermissions, employeePermissionsPage} from "@/services/saleOpServices.ts";
import {message} from "antd";
import {findOrgList} from "@/services/externalPerson.ts";
import company from "@/pages/targetConfig/objectiveManage/component/Company";

const StaffConfiguration = () => {
  const {id} = useParams()
  const [search] = useSearchParams()
  const orgId = search.get('orgId')
  const listRef = useRef()
  const [state, setState] = useSetState<any>({
    open: false,
    openConfig: false,
    record: {},
    company: [],
  })

  useEffect(() => {
    getCompanyTree()
  }, []);
  
  const findNodeById = (tree, id) => {
    for (const node of tree) {
      if (node.id === id) {
        return node;
      } else if (node.children) { // 如果当前节点有子节点，则递归搜索
        const found = findNodeById(node.children, id);
        if (found) {
          return found;
        }
      }
    }
  }

  const companyRes = useMemo(() => {
    if(orgId && state.company?.length){
      const data =  findNodeById(state.company, orgId)
      return data ? [data] : []
    } else {
      return []
    }
  }, [orgId, state.company])

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      employeePermissionsPage({params: {pageId: current, pageSize}, data: {orgPermissionId: id, ...query}}).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const getCompanyTree = () => {
    findOrgList().then(res => {
      setState({company: res})
    })
  }

  const onDel = (id) => {
    SMessage.delete({
      onOk(){
        return employeePermissions(id).then(res => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      }
    })
  }

  const onAdd = () => {
    setState({open: true})
  }

  const onConfig = (record = {}) => {
    setState({openConfig: true, record})

  }

  const extension = {
    request: {fetchList},
    events: {onAdd},
    searchMode: 'group',
    customRender: {
      actionRender(_, record){
        return <STableActions>
          <SActionBtn danger onClick={() => onDel(record.id)}>删除</SActionBtn>
          <SActionBtn onClick={() => onConfig(record)}>配置范围</SActionBtn>
        </STableActions>
      }
    }
  }

  return <SBack level={2} title={'人员列表'}>
    <SLowcodeList ref={listRef} config={config} {...extension} />
    {state.open && <AddOrEditDom {...state} companyList={companyRes} setOpen={(open) => setState({open})} reload={listRef.current?.reload}/>}
    {state.openConfig && <AddOrEditRange {...state} setOpen={(openConfig) => setState({openConfig})} reload={listRef.current?.reload}/>}
  </SBack>
}

export default StaffConfiguration